import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { toast } from "react-toastify";
import AdminNav from "./AdminNav";
import config from "../../../function/config";
import Footer from "../../Footer";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Usernav from "../../UserHome/Usernav";
import { loadStripe } from "@stripe/stripe-js";
import { formatDistanceToNow } from "date-fns";
import NewAdminNav from "./NewAdminNav";
import NewFooter from "../../NewFooter";

export default function AdminSingleShip() {
  const [showPaymentModal, setShowPaymentModal] = useState(false); // Payment plan modal
  const [hasPaid, setHasPaid] = useState(false); // Track if payment is done
  const [userPlan, setUserPlan] = useState("free"); // default free plan

  const stripePromise = loadStripe(
    "pk_test_51S0Hq4AoFmIatDnEm7xiA3Q1tcRmUtOczUSEa4XbdYmLj7JlIYYKchpMr6Ep7EquYVkMcwq6xXdjlAcSoA1xg44Q00ow8ldvSZ"
  );
  const shipRef = useRef();

  const { id } = useParams();

  const [user, setUser] = useState(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    async function fetchdata() {
      try {
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewusers`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          }
        );
        console.log("API response:", res2.data);
        if (res2.data.status === 200) {
          console.log("User:", res2);
          setUser(res2.data.data);
        } else {
          console.log(res2);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [token]);

  useEffect(() => {
    async function fetchUserPlan() {
      if (!token) return;

      try {
        const res = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/userShipsCount`,
          {
            headers: { Authorization: `Token ${token}` },
          }
        );
        if (res.data.status === 200) {
          setUserPlan(res.data.plan); // plan could be 'free', 'basic', 'premium', 'platinum'
        }
      } catch (err) {
        console.log("Error fetching user plan:", err);
      }
    }

    fetchUserPlan();
  }, [token]);

  const handlePlanClick = async (plan) => {
    try {
      const isFromReg = obj?.isFromReg || false;
      const shipId = id;

      const res = await axios.post(
        `${config.base_url}/api/HappyMarineShipping/create-checkout-session/`,
        {
          plan,
          ship_id: shipId,
          ship_type: "admin", // 👈 important
          success_url: `${window.location.origin}/adminSingleShip/${id}?payment=success&session_id={CHECKOUT_SESSION_ID}`,
          cancel_url: window.location.href,
        },
        { headers: { Authorization: `Token ${token}` } }
      );

      const stripe = await stripePromise;
      await stripe.redirectToCheckout({ sessionId: res.data.id });
    } catch (err) {
      console.error("Stripe checkout error:", err);
      toast.error("Payment failed to initialize");
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payment = params.get("payment");
    const sessionId = params.get("session_id"); // ✅ already clean, no ?payment=success

    if (payment === "success" && sessionId && id) {
      verifyPayment(sessionId);
    }
  }, [token, id]);

  const verifyPayment = async (sessionId) => {
    try {
      const shipId = obj.isFromReg ? obj.registered_ship_id : id; // use param id
      const shipType = obj.isFromReg ? "customer" : "admin";

      if (!shipId || !shipType) {
        toast.error("Missing ship_id or ship_type");
        return;
      }

      const res = await axios.post(
        `${config.base_url}/api/HappyMarineShipping/verify-payment/`,
        {
          session_id: sessionId,
          ship_id: id,
          ship_type: "admin",
        },
        { headers: { Authorization: `Token ${token}` } }
      );

      console.log("Payment verification response:", res.data);

      if (res.data.message === "Payment verified") {
        const planRes = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/getUserPlan/`,
          { headers: { Authorization: `Token ${token}` } }
        );
        if (planRes.data.status === 200) {
          setUserPlan(planRes.data.plan);
          toast.success("Plan upgraded successfully!");
          setShowPaymentModal(false);
          handleOwnerInfo();
          window.history.replaceState(
            {},
            document.title,
            window.location.pathname
          );
        }
      } else {
        toast.error(res.data.message || "Payment verification failed!");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Could not verify payment.");
    }
  };

  
const handleOwnerInfo = async () => {
  // 🟢 If modal is already open, close it immediately (toggle behavior)
  if (showModal) {
    setShowModal(false);
    return;
  }

  // 🟢 If superuser, just toggle open (since above handles close)
  if (user?.is_superuser) {
    setShowModal(true);
    return;
  }

  try {
    const res = await axios.get(
      `${config.base_url}/api/HappyMarineShipping/get_owner_info/${id}/`,
      { headers: { Authorization: `Token ${token}` } }
    );

    if (res.data.owner_info) {
      setEmail(res.data.owner_info.email);
      setMobile(res.data.owner_info.phone);
      setShowModal(true);
    }
  } catch (err) {
    if (err.response?.status === 403) {
      setShowPaymentModal(true);
    } else {
      toast.error("Could not fetch owner info");
    }
  }
};

  const handleDownload = () => {
    const element = shipRef.current;
    if (!element) {
      console.error("No element found to export.");
      return;
    }

    // Hide visual-only elements
    const dropdown = document.querySelector(".animate-fade-in");
    const shareButton = document
      .querySelector(".fa-share-nodes")
      ?.closest("button");
    const enquiryButton = document.querySelector("button.text-black");

    if (dropdown) dropdown.style.display = "none";
    if (shareButton) shareButton.style.display = "none";
    if (enquiryButton) enquiryButton.style.display = "none";

    // Show PDF-only layout
    element.style.display = "block";

    // Wait for all images inside the element to load
    const images = element.querySelectorAll("img");
    const imagePromises = Array.from(images).map((img) => {
      return new Promise((resolve) => {
        if (img.complete) {
          resolve();
        } else {
          img.onload = img.onerror = resolve;
        }
      });
    });

    Promise.all(imagePromises).then(() => {
      html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: false, // safer option
        scrollY: -window.scrollY,
        backgroundColor: "#123d5f",
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const imgWidth = pageWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let position = 0;
        let heightLeft = imgHeight;

        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft > 0) {
          position -= pageHeight;
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        // Restore
        element.style.display = "none";
        if (dropdown) dropdown.style.display = "";
        if (shareButton) shareButton.style.display = "";
        if (enquiryButton) enquiryButton.style.display = "";

        pdf.save("ship-details.pdf");
      });
    });
  };

  const [obj, setObj] = useState({});

  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenS, setIsOpenS] = useState(true);

  const [isScrolled, setIsScrolled] = useState(false);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/single/${id}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.data.status === 200) {
          console.log(res);
          setObj(res.data.data);
        } else {
          console.log(res);
        }
      } catch (err) {
        console.log("error2", err);
      }
    }
    fetchdata();
  }, [config.base_url]);

  const [Amenities, setAmenities] = useState([]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/singleAmenity/${id}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.data.status === 200) {
          console.log(res);
          setAmenities(res.data.data);
        } else {
          console.log(res);
        }
      } catch (err) {
        console.log("error2", err);
      }
    }
    fetchdata();
  }, [config.base_url]);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  const [allImages, setallImages] = useState([]);

  const [thumbnailImage, setThumbnailImage] = useState("");
  const [mainImages, setMainImages] = useState([]); // Store multiple images

  useEffect(() => {
    async function fetchShipImages() {
      try {
        const response = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/singleShipImage/${id}`
        );

        if (response.data.status === 200 && response.data.data.length > 0) {
          console.log("Fetched Images Data:", response.data.data);

          // Extract thumbnail image
          const thumbnailImageData = response.data.data.find(
            (img) => img.thumbnail_image !== null
          );
          setThumbnailImage(
            thumbnailImageData ? thumbnailImageData.thumbnail_image : ""
          );

          // Extract all main images
          const mainImagesData = response.data.data
            .filter((img) => img.image !== null)
            .map((img) => img.image);
          setMainImages(mainImagesData);

          console.log(
            "Thumbnail Image URL:",
            thumbnailImageData
              ? thumbnailImageData.thumbnail_image
              : "No Thumbnail Found"
          );
          console.log("Main Images Array:", mainImagesData);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    }

    fetchShipImages();
  }, [id]);

  const shipImages = allImages.filter((img) => img.ship === id);

const location = useLocation();
  

  const prevPage = location.state?.prevPage;
const prevPageNumber = location.state?.prevPageNumber;

const handleBack = () => {
  if (prevPage && (prevPage.startsWith("/user") || prevPage.startsWith("/admin"))) {
    navigate(`${prevPage}?page=${prevPageNumber || 1}`);
  } else {
    // Fallback based on role
    if (localStorage.getItem("admin") === "t") {
      navigate(`/adminShipForSale?page=1`);
    } else {
      navigate(`/userShipForSale?page=1`);
    }
  }
};

  const [isOpenModal, setIsOpenModal] = useState(false); // for dropdown
  const [showModal, setShowModal] = useState(false); // for enquiry modal
  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Subject, setSubject] = useState("");
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(1);

  const EnquirySubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("name", Name);
    formData.append("email", Email);
    formData.append("mobile", Mobile);
    formData.append("subject", Subject);

    try {
      const response = await axios.post(
        `${config.base_url}/api/HappyMarineShipping/add_enquiry`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.status === 200) {
        console.log(response);
        setLoading(false);
        setShowModal(false);
        toast.success("Sent Successfully!", {
          autoClose: 1500,
          position: "top-right",
        });
        setCount(id);
      } else {
        setLoading(false);
        console.log("error1");
        toast.error("Fill the required Fields", {
          autoClose: 1500,
          position: "top-right",
        });
      }
    } catch (err) {
      setLoading(false);
      console.log("error2", err);
      toast.error("Error", {
        autoClose: 2000,
        position: "top-right",
      });
    }
  };

  const [allShips, setallShips] = useState([]);
  const [allShipsReg, setallShipsReg] = useState([]);

  // Fetch Admin Ships
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewShip`,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (res1.data.status === 200) {
          const sortedData = res1.data.data.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setallShips(sortedData);
          setCount(id);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);

  // Fetch Customer Registered Ships
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewShipForSale`,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (res1.data.status === 200) {
          // Sort using created_at (not date_added)
          const sortedData = res1.data.data.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setallShipsReg(sortedData);
          setCount(id);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res3 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/ship_images`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res3.data.status === 200) {
          console.log("Images :", res3);
          setallImages(res3.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);

  const [allImagesReg, setAllImagesReg] = useState([]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res3 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/ship_images_Reg`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res3.data.status === 200) {
          console.log("Images :", res3);
          setAllImagesReg(res3.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);

  // Add an identifier to distinguish Admin Ships and Customer Ships
  const filteredAllShipsReg = allShipsReg
    .filter((ship) => ship.is_allow)
    .map((ship) => ({ ...ship, isFromReg: true })); // Mark as from RegisterShipForSale

  const allShipsWithFlag = allShips.map((ship) => ({
    ...ship,
    isFromReg: false,
  })); // Mark as Admin Ship

  // Merge and sort ships by created_at (latest first)
  const sortedData = [...allShipsWithFlag, ...filteredAllShipsReg].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  function shuffleArray(array) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }

  const similarShips = shuffleArray(
    sortedData.filter(
      (ship) => ship.vessel_type === obj.vessel_type && ship.id !== obj.id
    )
  );

  const [selectedImage, setSelectedImage] = useState(null);

  // Add this above your return block or inside the component
  const handleCloseModal = () => setSelectedImage(null);

  const [showShareOptions, setShowShareOptions] = useState(false);

  const shareRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (shareRef.current && !shareRef.current.contains(event.target)) {
        setShowShareOptions(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!token) {
      navigate("/login"); // login page
    }
  }, [token, navigate]);

   const [showOwnerInfo, setShowOwnerInfo] = useState(false);
  const btnRef = useRef(null);
  const panelRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    function onDocClick(e) {
      if (!showOwnerInfo) return;
      const clickedInsidePanel = panelRef.current?.contains(e.target);
      const clickedButton = btnRef.current?.contains(e.target);
      if (!clickedInsidePanel && !clickedButton) setShowOwnerInfo(false);
    }
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [showOwnerInfo]);

  return (
    <div className="bg-[#9ccee2]">
      {user ? user.is_superuser ? <NewAdminNav /> : <Usernav /> : null}

      <div className="px-10 lg:hidden mt-5">
        <button className="text-white" onClick={handleBack}>
          <i class="bx bx-chevrons-left bx-flashing bx-flip-vertical"></i> Back
        </button>
      </div>
     

      <div className="px-10 xm:px-2 hidden lg:block mt-5">
        <button className="text-white" onClick={handleBack}>
          <i class="bx bx-chevrons-left bx-flashing bx-flip-vertical"></i> Back
        </button>
      </div>

      <div className="flex gap-5   2xl:block  xm:p-3  mb-10 px-10">
        {/* 2nd div description */}
        <div className="w-[70%] 2xl:w-[100%] h-full 2xl:mt-5 border rounded    border-gray-400 bg-white flex flex-col ">
          <div
            ref={shipRef}
            className="hidden-for-pdf w-full bg-white p-4 text-[#2e5775]"
          >
            {/* 1. Ship Image */}
            <div className="w-full mb-4">
              {mainImages.length > 0 ? (
                <img
                  src={mainImages[0]}
                  className="w-[700px] xm:h-auto xm:w-auto m-auto h-[450px]"
                  alt="Ship Image"
                />
              ) : (
                <img
                  src="fallback.jpg"
                  className="w-[700px] xm:h-auto xm:w-auto m-auto h-[450px]"
                  alt="No Image"
                />
              )}
            </div>

            {/* 2. Short Description and Specs */}
            <div className="mb-4">
              {obj.short_description && (
                <div className="mb-2">
                  <strong className="text-[#2e5775]">Short Description:</strong>{" "}
                  {obj.short_description}
                </div>
              )}
              {obj.year_built && (
                <div>
                  <strong>Year Built:</strong>{" "}
                  <span className="text-[#2e5775]">{obj.year_built}</span>
                </div>
              )}
              {obj.LOA && (
                <div>
                  <strong>LOA:</strong>{" "}
                  <span className="text-[#2e5775]">{obj.LOA}</span>
                </div>
              )}
              {obj.Flag && (
                <div>
                  <strong>Flag:</strong>{" "}
                  <span className="text-[#2e5775]">{obj.flag}</span>
                </div>
              )}
              {obj.Class && (
                <div>
                  <strong>Class:</strong>{" "}
                  <span className="text-[#2e5775]">{obj.Class}</span>
                </div>
              )}
              {obj.GRT_NRT && (
                <div>
                  <strong>GRT/NRT:</strong>{" "}
                  <span className="text-[#2e5775]">{obj.GRT_NRT}</span>
                </div>
              )}
              {obj.Teu && (
                <div>
                  <strong>Teu:</strong>{" "}
                  <span className="text-[#2e5775]">{obj.Teu}</span>
                </div>
              )}
              {obj.DWT && (
                <div>
                  <strong>DWT:</strong>{" "}
                  <span className="text-[#2e5775]">{obj.DWT}</span>
                </div>
              )}
              {obj.Price && (
                <div>
                  <strong>Price:</strong>{" "}
                  <span className="text-[#2e5775]">{obj.Price}</span>
                </div>
              )}
              {obj.main_engine && (
                <div>
                  <strong>Main Engine:</strong>{" "}
                  <span className="text-[#2e5775]">{obj.main_engine}</span>
                </div>
              )}
            </div>

            {/* 3. More Informations */}
            <div>
              <h2 className="text-xl font-bold text-[#2e5775] mb-2">
                More Informations
              </h2>
              {obj.brief_description ? (
                obj.brief_description.split("\n").map((line, idx) => (
                  <p key={idx} className="mb-1 whitespace-pre-wrap break-words">
                    {line}
                  </p>
                ))
              ) : (
                <p className="text-red-400">No description available</p>
              )}
            </div>
          </div>
          <div className=" rounded-t ">
            <div className="text-gray-200 ">
              <div className="px-3 py-3">
                <div className="flex justify-between xm:text-lg xm:px-2 items-center rounded bg-[#2e5775] py-3 text-white font-bold text-xl px-4 cursor-pointer">
                  <h1 className="">Short Descriptions</h1>
                  <h1 className="">
                    {" "}
                    Ref : {obj.ship_code} - {id}
                  </h1>
                </div>
              </div>

              <div className="flex justify-between  text-[#2e5775] md:flex-wrap-reverse px-3 w-[100%]">
                <div className="px-3 py-3 w-[90%]">
                  {/* Short Description */}
                  {obj.short_description && (
                    <div className="flex gap-3 border-b border-gray-300 py-1">
                      <span className="text-[#2e5775]   font-bold px-1  ">
                        {obj.short_description}
                      </span>
                    </div>
                  )}

                  {/* LOA and Built Year */}
                  {(obj.LOA || obj.year_built) && (
                    <div className="mt-3">
                      {obj.year_built && (
                        <div className="w-full">
                          <span className="font-semibold  ">Year Built:</span>
                          <span className="text-[#2e5775] ml-[27px]">
                            {obj.year_built}
                          </span>
                        </div>
                      )}
                      {obj.LOA && (
                        <div className="w-full ">
                          <span className="font-semibold  ">LOA:</span>
                          <span className="text-[#2e5775] ml-[72px]">
                            {obj.LOA}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                  {/* Flag and Capacity */}
                  {(obj.flag || obj.capacity) && (
                    <div className=" ">
                      {obj.flag && (
                        <div className="w-full">
                          <span className="font-semibold  ">Flag:</span>
                          <span className="text-[#2e5775] ml-[70px]">
                            {obj.flag}
                          </span>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Class and GRT/NRT */}
                  {Amenities && (
                    <div className="">
                      {Amenities.find(
                        (amenity) => amenity.name === "Class" && amenity.value
                      ) && (
                        <div className="w-full">
                          <span className="font-semibold ">Class:</span>
                          <span className="text-[#2e5775] ml-[60px]">
                            {
                              Amenities.find(
                                (amenity) => amenity.name === "Class"
                              ).value
                            }
                          </span>
                        </div>
                      )}

                      {Amenities.find(
                        (amenity) => amenity.name === "Grt/Nrt" && amenity.value
                      ) && (
                        <div className="w-full">
                          <span className="font-semibold ">GRT/NRT:</span>
                          <span className="text-[#2e5775] ml-[34px]">
                            {
                              Amenities.find(
                                (amenity) => amenity.name === "Grt/Nrt"
                              ).value
                            }
                          </span>
                        </div>
                      )}

                      {Amenities.find(
                        (amenity) => amenity.name === "Teu" && amenity.value
                      ) && (
                        <div className="w-full">
                          <span className="font-semibold ">Teu:</span>
                          <span className="text-[#2e5775] ml-[77px]">
                            {
                              Amenities.find(
                                (amenity) => amenity.name === "Teu"
                              ).value
                            }
                          </span>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Main Engine and DWT */}
                  {Amenities && (
                    <div className="">
                      {Amenities.find(
                        (amenity) => amenity.name === "DWT" && amenity.value
                      ) && (
                        <div className="w-full">
                          <span className="font-semibold ">DWT:</span>
                          <span className="text-[#2e5775] ml-[70px]">
                            {
                              Amenities.find(
                                (amenity) => amenity.name === "DWT"
                              ).value
                            }
                          </span>
                        </div>
                      )}
                      <div className=" ">
                        {obj.Price && (
                          <div className="w-full">
                            <span className="font-semibold ">Price:</span>
                            <span className="text-[#2e5775] ml-[68px]">
                              {obj.Price}
                            </span>
                          </div>
                        )}
                      </div>
                      {Amenities.find(
                        (amenity) =>
                          amenity.name === "Main Engine" && amenity.value
                      ) && (
                        <div className="w-full">
                          <span className="font-semibold ">Main Engine:</span>
                          <span className="text-[#2e5775] ml-1">
                            {
                              Amenities.find(
                                (amenity) => amenity.name === "Main Engine"
                              ).value
                            }
                          </span>
                        </div>
                      )}
                    </div>
                  )}

                  {/* <div className="w-full mt-5">
                                     <span
                                       onClick={() => navigate(`/shipLoc/${obj.id}`)}
                                       className=" text-blue-400 cursor-pointer hover:underline "
                                     >
                                       Track Location
                                     </span>
                                   </div> */}
                </div>

                <div className="w-[500px]  md:m-auto xm:w-full bg-[#123d5f] border p-2 border-gray-400">
                  <div className="w-full h-full relative cursor-pointer">
                    {mainImages.length > 0 ? (
                      <>
                        <img
                          src={mainImages[0]}
                          className="w-full xm:w-full h-full"
                          alt="Ship Image"
                          onClick={() => setSelectedImage(mainImages[0])}
                        />
                        {/* Hover Overlay */}
                        <div
                          onClick={() => setSelectedImage(mainImages[0])}
                          className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300"
                        >
                          <span className="text-white text-sm font-semibold underline">
                            Click here to view image
                          </span>
                        </div>

                        {/* Enlarge Icon */}
                        <div
                          onClick={() => setSelectedImage(mainImages[0])}
                          className="absolute bottom-2 right-2 bg-black bg-opacity-60 px-3 py-2 rounded-full hover:bg-opacity-90 transition"
                          title="Click to enlarge"
                        >
                          <i class="fa-solid fa-up-right-and-down-left-from-center  text-white"></i>
                        </div>
                      </>
                    ) : !thumbnailImage ? (
                      <img
                        src="fallback.jpg"
                        className="w-full h-full"
                        alt="No Image Available"
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {selectedImage && (
            <div
              className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
              onClick={handleCloseModal}
            >
              <div
                className="w-[1000px] h-[600px] xm:w-[500px] xm:h-[300px] overflow-auto"
                onClick={(e) => e.stopPropagation()}
              >
                <Swiper
                  modules={[Navigation, Pagination]}
                  navigation
                  pagination={{ clickable: true }}
                  loop={true}
                  initialSlide={mainImages.findIndex(
                    (img) => img === selectedImage
                  )}
                  className="w-full h-full"
                >
                  {mainImages.map((image, index) => (
                    <SwiperSlide key={index}>
                      <div
                        onClick={handleCloseModal}
                        className="absolute top-2 right-2 cursor-pointer bg-opacity-60 px-4 py-2 rounded-full hover:bg-opacity-90 transition"
                      >
                        <h1 className="text-red-600 font-bold text-2xl ">X</h1>
                      </div>
                      <img
                        src={image}
                        onClick={handleCloseModal}
                        alt={`Enlarged ${index}`}
                        className="rounded-lg w-full h-full m-auto"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          )}

          <div className="px-3 py-3">
            <div className="border rounded border-gray-400">
              {/* Dropdown Header */}
              <div className="flex justify-between rounded items-center bg-[#2e5775] py-3 text-white font-bold text-xl px-4 cursor-pointer">
                <h1>More Informations</h1>
                <div className="relative flex gap-4" ref={shareRef}>
                  <button
                    onClick={() => setShowShareOptions(!showShareOptions)}
                    className="flex items-center gap-2 bg-white text-[#2e5775] border border-[#d1a460] rounded-full px-4 py-1.5 text-sm font-semibold hover:bg-[#8f7b5d] hover:text-white transition-all duration-300 shadow-sm"
                  >
                    <i className="fa-solid fa-share-nodes"></i> Share
                  </button>

                  {showShareOptions && (
                    <div className="absolute right-0 mt-2 w-60 bg-white border border-gray-300 rounded-xl shadow-xl z-50 animate-fade-in">
                      {/* Regular WhatsApp */}
                      <button
                        onClick={() => {
                          const url = window.location.href;
                          const message = `Check out this ship listing: ${url}`;
                          window.open(
                            `https://wa.me/?text=${encodeURIComponent(
                              message
                            )}`,
                            "_blank"
                          );
                          setShowShareOptions(false);
                        }}
                        className="w-full flex items-center gap-2 px-4 py-2 text-green-600 hover:bg-green-50 transition-all"
                      >
                        <i className="fa-brands fa-whatsapp text-lg"></i>{" "}
                        WhatsApp
                      </button>

                      <button
                        onClick={() => {
                          handleDownload();
                          setShowShareOptions(false);
                        }}
                        className="w-full flex items-center gap-2 px-4 py-2 text-red-600 hover:bg-red-50 transition-all"
                      >
                        <i className="fa-solid fa-file-pdf text-lg"></i>{" "}
                        Download as PDF
                      </button>

                      {/* WhatsApp Beta */}
                      {/* <button
                                                  onClick={() => {
                                                    const url = window.location.href;
                                                    const message = `Check out this ship listing: ${url}`;
                                                    // WhatsApp Beta URL scheme (typically used with beta installs)
                                                    window.open(`https://web.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
                                                    setShowShareOptions(false);
                                                  }}
                                                  className="w-full flex items-center gap-2 px-4 py-2 text-green-800 hover:bg-green-100 transition-all"
                                                >
                                                  <i className="fa-brands fa-whatsapp text-lg"></i> WhatsApp Beta
                                                </button> */}

                      {/* Email */}
                      <button
                        onClick={() => {
                          const subject = "Ship Listing";
                          const body = `Check out this ship: ${window.location.href}`;
                          window.location.href = `mailto:?subject=${encodeURIComponent(
                            subject
                          )}&body=${encodeURIComponent(body)}`;
                          setShowShareOptions(false);
                        }}
                        className="w-full flex items-center gap-2 px-4 py-2 text-blue-600 hover:bg-blue-50 transition-all"
                      >
                        <i className="fa-solid fa-envelope text-lg"></i> Email
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Dropdown Content */}

              <div className="relative p-3  text-base text-[#2e5775]">
                <div className="pr-32">
                  {obj.brief_description ? (
                    obj.brief_description.split("\n").map((detail, index) => {
                      const urlRegex = /(https?:\/\/[^\s]+)/g;
                      const parts = detail.split(urlRegex);

                      return (
                        <p
                          key={index}
                          className="mb-2 break-words whitespace-pre-wrap"
                        >
                          {parts.map((part, i) =>
                            urlRegex.test(part) ? (
                              <a
                                key={i}
                                href={part}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 underline hover:text-blue-800 break-words"
                              >
                                {part}
                              </a>
                            ) : (
                              <span key={i}>{part}</span>
                            )
                          )}
                        </p>
                      );
                    })
                  ) : (
                    <p className="text-red-500">No description available</p>
                  )}
                </div>

                {/* Enquiry Button */}
               <div className="absolute right-2 top-5">
  <button
    onClick={handleOwnerInfo} // toggle on click
    className={`bg-gray-50  text-lg duration-300 text-black border border-[#a1ccec] 
                hover:bg-[#123d5f] hover:text-white rounded-md px-3 py-2 shadow-lg 
                hover:shadow-xl transition text-left
                ${showModal ? "w-96 xm:w-full" : "w-64 xm:w-full"}`}  // wider when open
  >
    <div className="flex justify-between items-center">
      <span>Owner Informations</span>
      <span className="ml-2">{showModal ? "▲" : "▼"}</span>
    </div>

    {/* Expanded Details inside button */}
    {showModal && (
      <div className="mt-2 bg-white border border-[#a1ccec] rounded-md p-3 shadow-inner text-gray-700 space-y-2">
        <div className="text-lg">
          <span className="font-semibold text-gray-900">Email:</span>{" "}
          <span className="break-all">{obj.email}</span>
        </div>
        <div className="text-lg">
          <span className="font-semibold text-gray-900">Mobile:</span>{" "}
          <span>{obj.phone}</span>
        </div>
        <div className="text-lg">
          <span className="font-semibold text-gray-900">Created At:</span>{" "}
          <span>
            {formatDistanceToNow(new Date(obj.created_at), { addSuffix: true })}
          </span>
        </div>
      </div>
    )}
  </button>
</div>





                {showPaymentModal && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-white w-[500px] xm:w-auto rounded-lg shadow-lg relative">
                      <div className="bg-[#123d5f] px-6 py-3 flex justify-between">
                        <h2 className="text-2xl font-bold text-white">
                          Choose a Payment Plan
                        </h2>
                        <button
                          onClick={() => setShowPaymentModal(false)}
                          className="text-2xl font-bold text-red-500"
                        >
                          X
                        </button>
                      </div>

                      <div
                        className="border p-4 rounded-lg hover:shadow-md cursor-pointer"
                        // onClick={() => handlePlanClick("One_Time")}
                      >
                        <h3 className="font-bold text-lg">
                          One Time Payment - $10
                        </h3>
                        <p>Access Owner Information for this ship.</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* 🟦 Modal */}
          
        </div>

        {/*3rd similar ships */}
        <div className="w-[25%] 2xl:w-[100%] 2xl:mt-5 h-full overflow-y-auto border bg-[#2e5775] border-gray-400 rounded  p-2">
          <h2 className="text-white text-lg font-semibold mb-2">
            Similar Ships
          </h2>
          {similarShips.length > 0 ? (
            similarShips.slice(0, 3).map((ship) => (
              <div key={ship.id} className="bg-white mb-3 p-2 rounded shadow">
                <p className="font-bold text-gray-800">
                  {ship.short_description}
                </p>
                <p className="text-sm text-gray-600">
                  Type: {ship.vessel_type}
                </p>
                <p className="text-sm text-gray-600">Flag: {ship.flag}</p>
                {/* Optionally show thumbnail */}
                <div>
                  {(() => {
                    let imageUrl = null;

                    const images = ship.isFromReg
                      ? allImagesReg.filter((img) => img.ships === ship.id)
                      : allImages.filter((img) => img.ship === ship.id);

                    imageUrl = images[0]?.image;

                    if (!imageUrl) return null;

                    const route = ship.is_allow
                      ? `/adminsingleRegshipforsale/${ship.id}`
                      : `/adminSingleShip/${ship.id}`;

                    return (
                      <img
                        onClick={() => {
                          navigate(route);
                          window.location.reload(); // Refresh after navigation
                        }}
                        src={imageUrl}
                        className="w-full h-[150px] cursor-pointer mt-1 rounded"
                        alt="Ship"
                      />
                    );
                  })()}
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-200">No similar ships found</p>
          )}
        </div>
      </div>

      <NewFooter />
    </div>
  );
}
